/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-29 11:33:45
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-09 14:49:38
 * @FilePath: \hnkjfw-gw\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "",
        name: "home",
        meta: {
          title: "河南省科技创新促进中心-首页",
          requiresDesktop: true,
        },
        component: () => import("@/views/home/HomeView.vue"),
      },

      {
        path: "/xwzx",
        meta: {
          title: "河南省科技创新促进中心-新闻中心",
        },
        component: () => import("@/views/xwzx/Xwzx.vue"),
        children: [
          {
            path: "",
            name: "Gzdt",
            meta: {
              title: "河南省科技创新促进中心-工作动态",
            },
            component: () => import("@/views/xwzx/pages/Gzdt.vue"),
          },
          {
            path: "zxhd",
            name: "Zxhd",
            meta: {
              title: "河南省科技创新促进中心-中心活动",
            },
            component: () => import("@/views/xwzx/pages/Zxhd.vue"),
          },
          {
            path: "tzgg",
            name: "Tzgg",
            meta: {
              title: "河南省科技创新促进中心-通知公告",
            },
            component: () => import("@/views/xwzx/pages/Tzgg.vue"),
          },
          {
            path: "kjyw",
            name: "Kjyw",
            meta: {
              title: "河南省科技创新促进中心-科技要闻",
            },
            component: () => import("@/views/xwzx/pages/Kjyw.vue"),
          },
        ],
      },
      {
        path: "/commonDetail",
        component: () => import("@/components/CommonDetailPage.vue"),
      },
      {
        path: "/dqgz",
        meta: {
          title: "河南省科技创新促进中心-党群工作",
        },
        component: () => import("@/views/dqgz/Dqgz.vue"),
        children: [
          {
            path: "",
            name: "Dqhd",
            meta: {
              title: "河南省科技创新促进中心-党群活动",
            },
            component: () => import("@/views/dqgz/pages/Dqhd.vue"),
          },
          {
            path: "jswm",
            name: "Jswm",
            meta: {
              title: "河南省科技创新促进中心-精神文明",
            },
            component: () => import("@/views/dqgz/pages/Jswm.vue"),
          },
        ],
      },
      {
        path: "/zxyw",
        meta: {
          title: "河南省科技创新促进中心-中心业务",
        },
        component: () => import("@/views/zxyw/Zxyw.vue"),
      },
      {
        path: "/jggk",
        meta: {
          title: "河南省科技创新促进中心-机构概况",
        },
        component: () => import("@/views/jggk/Jggk.vue"),
        children: [
          {
            path: "",
            name: "Zxjj",
            meta: {
              title: "河南省科技创新促进中心-中心简介",
            },
            component: () => import("@/views/jggk/pages/Zxjj.vue"),
          },
          {
            path: "zxld",
            name: "Zxld",
            meta: {
              title: "河南省科技创新促进中心-中心领导",
            },
            component: () => import("@/views/jggk/pages/Zxld.vue"),
          },
          {
            path: "zzjg",
            name: "Zzjg",
            meta: {
              title: "河南省科技创新促进中心-组织架构",
            },
            component: () => import("@/views/jggk/pages/Zzjg.vue"),
          },
          {
            path: "bmjj",
            name: "Bmjj",
            meta: {
              title: "河南省科技创新促进中心-部门简介",
            },
            component: () => import("@/views/jggk/pages/Bmjj.vue"),
          },
        ],
      },
      {
        path: "/lxwm",
        meta: {
          title: "河南省科技创新促进中心-联系我们",
        },
        component: () => import("@/views/lxwm/Lxwm.vue"),
      },
      {
        path: "/search",
        meta: {
          title: "河南省科技创新促进中心-搜索",
        },
        component: () => import("@/views/home/SearchListPage.vue"),
      },
    ],
  },
  {
    path: "/wxshare",
    meta: {
      title: "微信分享",
    },
    component: () => import("@/components/WxSharePage.vue"),
  },

  // --------------------------------手机端---------------------------------------
  {
    path: "/phone",
    component: () => import("@/views/layout/indexPhone.vue"),
    children: [
      {
        path: "",
        name: "home",
        meta: {
          title: "河南省科技创新促进中心-首页",
          requiresMobile: true,
        },
        component: () => import("@/views/home/HomeViewPhone.vue"),
      },

      {
        path: "/xwzxPhone",
        meta: {
          title: "河南省科技创新促进中心-新闻中心",
        },
        component: () => import("@/views/xwzx/XwzxPhone.vue"),
        children: [
          {
            path: "",
            name: "GzdtPhone",
            meta: {
              title: "河南省科技创新促进中心-工作动态",
            },
            component: () => import("@/views/xwzx/pages/GzdtPhone.vue"),
          },
          {
            path: "zxhdPhone",
            name: "ZxhdPhone",
            meta: {
              title: "河南省科技创新促进中心-中心活动",
            },
            component: () => import("@/views/xwzx/pages/ZxhdPhone.vue"),
          },
          {
            path: "tzggPhone",
            name: "TzggPhone",
            meta: {
              title: "河南省科技创新促进中心-通知公告",
            },
            component: () => import("@/views/xwzx/pages/TzggPhone.vue"),
          },
          {
            path: "kjywPhone",
            name: "KjywPhone",
            meta: {
              title: "河南省科技创新促进中心-科技要闻",
            },
            component: () => import("@/views/xwzx/pages/KjywPhone.vue"),
          },
        ],
      },
      {
        path: "/commonDetailPhone",
        component: () => import("@/components/CommonDetailPagePhone.vue"),
      },
      {
        path: "/dqgzPhone",
        meta: {
          title: "河南省科技创新促进中心-党群工作",
        },
        component: () => import("@/views/dqgz/DqgzPhone.vue"),
        children: [
          {
            path: "",
            name: "DqhdPhone",
            meta: {
              title: "河南省科技创新促进中心-党群活动",
            },
            component: () => import("@/views/dqgz/pages/DqhdPhone.vue"),
          },
          {
            path: "jswmPhone",
            name: "JswmPhone",
            meta: {
              title: "河南省科技创新促进中心-精神文明",
            },
            component: () => import("@/views/dqgz/pages/JswmPhone.vue"),
          },
        ],
      },
      {
        path: "/zxywPhone",
        meta: {
          title: "河南省科技创新促进中心-中心业务",
        },
        component: () => import("@/views/zxyw/ZxywPhone.vue"),
      },
      {
        path: "/jggkPhone",
        meta: {
          title: "河南省科技创新促进中心-机构概况",
        },
        component: () => import("@/views/jggk/JggkPhone.vue"),
        children: [
          {
            path: "",
            name: "ZxjjPhone",
            meta: {
              title: "河南省科技创新促进中心-中心简介",
            },
            component: () => import("@/views/jggk/pages/ZxjjPhone.vue"),
          },
          {
            path: "zxldPhone",
            name: "ZxldPhone",
            meta: {
              title: "河南省科技创新促进中心-中心领导",
            },
            component: () => import("@/views/jggk/pages/ZxldPhone.vue"),
          },
          {
            path: "zzjgPhone",
            name: "ZzjgPhone",
            meta: {
              title: "河南省科技创新促进中心-组织架构",
            },
            component: () => import("@/views/jggk/pages/ZzjgPhone.vue"),
          },
          {
            path: "bmjjPhone",
            name: "BmjjPhone",
            meta: {
              title: "河南省科技创新促进中心-部门简介",
            },
            component: () => import("@/views/jggk/pages/BmjjPhone.vue"),
          },
        ],
      },
      {
        path: "/lxwmPhone",
        meta: {
          title: "河南省科技创新促进中心-联系我们",
        },
        component: () => import("@/views/lxwm/LxwmPhone.vue"),
      },
      {
        path: "/searchPhone",
        meta: {
          title: "河南省科技创新促进中心-搜索",
        },
        component: () => import("@/views/home/SearchListPagePhone.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  const isMobile = window.innerWidth < 768; // 设置移动设备的屏幕分辨率阈值
  if (to.matched.some((record) => record.meta.requiresMobile) && !isMobile) {
    next("/"); // 如果路由需要移动设备而当前是桌面设备，则跳转到桌面路由
  } else if (
    to.matched.some((record) => record.meta.requiresDesktop) &&
    isMobile
  ) {
    next("/phone"); // 如果路由需要桌面设备而当前是移动设备，则跳转到移动路由
  } else {
    next(); // 否则继续正常导航
  }
});
